import * as React from 'react';
import { Form, Formik } from 'formik';
import { getContainerTypes, sortContainerTypeList } from '../../helpers/extractFromContainers';
import { Container } from '../../types';

import ContainerListItem from '../ContainerListItem';

type Props = {
  containers: Container[]
  setExcluded: React.Dispatch<React.SetStateAction<Container['type'][]>>
  excluded: Container['type'][]
};

const ContainerList = (props: Props) => {
  const { containers, setExcluded, excluded } = props;
  const containerTypes = sortContainerTypeList(
    getContainerTypes(containers),
  );

  const onChangeFunction = (checked: boolean, type: Container['type']) => {
    if (checked && excluded.includes(type)) {
      const index = excluded.indexOf(type);
      excluded.splice(index, 1);
      setExcluded([...excluded]);
      return;
    }

    if (!checked && !excluded.includes(type)) {
      const newArray = [...excluded, type];
      setExcluded(newArray);
    }
  };

  return (
    <div className="ContainerList">
      <Formik
        initialValues={{}}
        onSubmit={() => {}}
      >
        <Form>
          {containerTypes.map((type) => (
            <ContainerListItem
              key={type}
              name={type}
              containers={containers}
              enabled={!excluded.includes(type)}
              onChange={(checked) => onChangeFunction(checked, type)}
            />
          ))}
        </Form>
      </Formik>
    </div>
  );
};

export default ContainerList;
